<template>
    <button class="FilterBtn" type="button" @click="openFiltersModal">
        <i class="lnr-equalizer Icon"></i> Filters
    </button>
</template>

<script setup lang="ts">
import { useMobile } from '@composables/useMobile';
import { useMobileModal } from '@composables/useMobileModal';
import Filters from '@components/Filters/Filters.vue';

const { isMobile } = useMobile();
const { open: openMobileModal } = useMobileModal();

const openFiltersModal = (): void => {
    if (!isMobile.value) return;

    openMobileModal(Filters);
};
</script>

<style scoped lang="scss">
.FilterBtn {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    border: 1px solid $Grey-900;
    border-radius: 0.25rem;
    cursor: pointer;
    background: $Grey-900;
    color: $White;
    height: 2rem;

    @include TextStyle(UiLargeRegular);
    @include PaddingAreas(0.5);

    .Icon {
        font-size: 1rem;
    }

    @include Breakpoint(Large, ExtraLarge) {
        display: none;
    }
}
</style>